
import {Component, Prop, Vue} from "vue-property-decorator";
import CashboxAddForm from "@/form/finance/cashbox/CashboxAddForm";
import FormGroup from "@/UI/components/common/form/FormGroup.vue";
import moment from 'moment';
import { checkUserRole, getUserData } from '@/router/Lib/helper';

@Component({
  components: {FormGroup},
  methods: {moment}
})
export default class CashboxAddComponent extends Vue {
  @Prop() readonly form!: CashboxAddForm;


  submit(): void {
    const Role = checkUserRole();
    const UserData = getUserData();

    if(Role == 'owner')
    {
      this.form.salon_id = UserData.studios;
    } else {
      this.form.salon_id = this.$store.state.salon_id;
    }
    this.$emit('submit');
  }

  onNumberChange(val: string): void{
    if(this.form.balance)
    {
      let value = this.form.balance.toString();
      this.form.balance = value.replace(/\D/gi, '');
      if(!this.form.balance){
        this.form.balance = '0';
      }
    }
  }
}
